<div class="main_plus_side">
    <div class="sidesheet_temp mat-elevation-z2">
        <ng-container *ngIf="periodosNavBar">
            <nav-bar [navBarItems]="periodosNavBar" [initialValue]="periodoID" [placeholder]="'Seleccione un año'" [navOnChange]="true" [verticalLayout]="true"></nav-bar>
        </ng-container>
        <nivelaciones-convenciones [direccion]="'vertical'" [asistencia]="true" [data]="tiposAsistencia" [dataFilterValues]="['A', 'A0', 'A1', 'A2', 'A3', 'R', 'R0', 'R1', 'R2', 'R3']"></nivelaciones-convenciones>
    </div>
    <div class="main_sheet">
        <div class="flex-wrap" style="align-items:center;">
            <div class="inline-flex" style="width: 30%">
                <mat-form-field class="full-width">
                    <input matInput placeholder="Filtrar por nombre" (keyup)="filtroTexto($event.target.value)" autocomplete="off">
                </mat-form-field>
            </div>
            <span class="spacer"></span>
            <div class="flex-wrap" style="align-items:center;">
                <label style="margin-right: 4px; opacity:.6;">Ver valores como:</label>
                <button mat-button class="view-mode" (click)="changeViewMode('percentage')" [ngStyle]="{'color': viewMode != 'numbers' ? 'blue' : 'inherit', 'text-decoration': viewMode != 'numbers' ? 'underline' : 'none'}" [ngClass]="{'active': viewMode != 'numbers'}">Porcentaje
        </button>
                <button mat-button class="view-mode" (click)="changeViewMode('numbers')" [ngStyle]="{'color': viewMode == 'numbers' ? 'blue' : 'inherit', 'text-decoration': viewMode == 'numbers' ? 'underline' : 'none'}" [ngClass]="{'active': viewMode == 'numbers'}">Numérico
        </button>
            </div>
        </div>
        <div *ngIf="dataSource; else loading">
            <mat-table #table [dataSource]="dataSource" matSort class="mat-elevation-z2">
                <ng-container matColumnDef="Curso">
                    <mat-header-cell *matHeaderCellDef style="flex: 1;">Curso</mat-header-cell>
                    <mat-cell *matCellDef="let element" style="flex: 1;">{{element.curso}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="Materia">
                    <mat-header-cell *matHeaderCellDef style="flex: 3;">Materia</mat-header-cell>
                    <mat-cell *matCellDef="let element" style="flex: 3;"><strong>{{element.nombre}}</strong> <br>
                        <small style="opacity: .6;"><span
              matTooltip="Horas dictadas hasta hoy">{{element.horasClase}}h</span> | <span
              matTooltip="Horas previstas">{{element.horasEsperadas}}h</span></small>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="FaltaTarea">
                    <mat-header-cell *matHeaderCellDef>Falta<br>de tareas</mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        <strong *ngIf="element.faltaTareaAcumula > 0">{{element.faltaTareaAcumula}}</strong>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="AyR">
                    <mat-header-cell *matHeaderCellDef style="flex: 1; text-align: center;">Ausencias <br>y retardos
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" style="flex: 1; text-align: center;">
                        <div style="position: relative;">
                            <div class="circulo" style="cursor: pointer;" *ngIf="element.numerico > 0 || element.porcentaje > 0" (click)="getDetails(element, element.id)">
                                <small>
                  {{viewMode == 'numbers' ? element.numerico : element.porcentaje + '%'}}
                </small>
                            </div>
                            <div *ngIf="element.detalle && element.detalle.show" class="detail-container mat-elevation-z24">
                                <ul class="detail-list">
                                    <li *ngFor="let alumnoDetalle of element.detalle.listaDetalles" class="flex-wrap">
                                        <p style="flex: 5; text-align: left">{{alumnoDetalle.alumno}}</p>
                                        <span class="spacer"></span>
                                        <p style="flex: 1; text-align: right">
                                            {{viewMode == 'numbers' ? alumnoDetalle.numerico : alumnoDetalle.porcentaje + '%'}}
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Alerta">
                    <mat-header-cell *matHeaderCellDef style="flex: 1; text-align: center;">
                        <mat-icon>warning</mat-icon>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" style="flex: 1; text-align: center;">{{element.alertas}}
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="s">
                    <mat-header-cell *matHeaderCellDef style="flex: 1; text-align: center;">S</mat-header-cell>
                    <mat-cell *matCellDef="let element" style="flex: 1; text-align: center;">
                        {{element.notasAcumuladas.nota1}}
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="a">
                    <mat-header-cell *matHeaderCellDef style="flex: 1; text-align: center;">A</mat-header-cell>
                    <mat-cell *matCellDef="let element" style="flex: 1; text-align: center;">
                        {{element.notasAcumuladas.nota2}}
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="b">
                    <mat-header-cell *matHeaderCellDef style="flex: 1; text-align: center;">B</mat-header-cell>
                    <mat-cell *matCellDef="let element" style="flex: 1; text-align: center;">
                        {{element.notasAcumuladas.nota3}}
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="d">
                    <mat-header-cell *matHeaderCellDef style="flex: 1; text-align: center;">D</mat-header-cell>
                    <mat-cell *matCellDef="let element" style="flex: 1; text-align: center;">
                        {{element.notasAcumuladas.nota4}}
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="i">
                    <mat-header-cell *matHeaderCellDef style="flex: 1; text-align: center;">I</mat-header-cell>
                    <mat-cell *matCellDef="let element" style="flex: 1; text-align: center;">
                        {{element.notasAcumuladas.nota5}}
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="di">
                    <mat-header-cell *matHeaderCellDef style="flex: 1; text-align: center;">D+I</mat-header-cell>
                    <mat-cell *matCellDef="let element" style="flex: 1; text-align: center;">
                        {{element.notasAcumuladas.reprobadosLetra}}
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="na">
                    <mat-header-cell *matHeaderCellDef style="flex: 1; text-align: center;">N.A.</mat-header-cell>
                    <mat-cell *matCellDef="let element" style="flex: 1; text-align: center;">
                        {{element.notasAcumuladas.reprobados}}
                    </mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let element; columns: displayedColumns;">
                </mat-row>
            </mat-table>
        </div>
        <ng-template #loading>
            <mat-spinner [mode]="'indeterminate'"></mat-spinner>
        </ng-template>
    </div>
</div>